import { Accordion } from "react-bootstrap";

import SectionEditor from "./SectionEditor";
import { ObjectFieldEditor } from "./ValueEditor";

const PageEditor = ({
  page,
  disabled = false,
  onChange,
  onUploadStart,
  onUploadEnd,
}) => {
  if (!page || typeof page !== "object") {
    return <p className="text-muted mb-0">Invalid page data.</p>;
  }

  const sections = Array.isArray(page.sections) ? page.sections : null;

  const updateSection = (index, nextSection) => {
    const nextSections = sections.map((section, i) =>
      i === index ? nextSection : section
    );
    onChange({ ...page, sections: nextSections });
  };

  if (sections) {
    if (!sections.length) {
      return <p className="text-muted mb-0">This page has no sections.</p>;
    }

    return (
      <Accordion alwaysOpen>
        {sections.map((section, index) => (
          <SectionEditor
            key={section?.id || `section-${index}`}
            section={section}
            disabled={disabled}
            onChange={(next) => updateSection(index, next)}
            onUploadStart={onUploadStart}
            onUploadEnd={onUploadEnd}
          />
        ))}
      </Accordion>
    );
  }

  return (
    <ObjectFieldEditor
      value={page}
      disabled={disabled}
      onChange={onChange}
      onUploadStart={onUploadStart}
      onUploadEnd={onUploadEnd}
      depth={0}
      hideId
      excludeKeys={["id"]}
    />
  );
};

export default PageEditor;
